import React from 'react';
import Library from './components/Library';

export default function App() {
  return (<Library />);
}